export const networkSchemaRootPaths: readonly string[] = ['org', 'network'];
